import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  dialogPaper: {
    maxHeight: 'calc(100vh - 64px)',
    overflow: 'hidden',
    width: 760,
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      maxHeight: '100%',
      width: '100%'
    }
  },
  titleRoot: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2.5, 7, 2.25, 3),
    position: 'relative'
  },
  title: {
    color: '#263238',
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.3
  },
  subtitle: {
    color: '#65747B',
    marginTop: theme.spacing(0.5)
  },
  closeButton: {
    color: theme.palette.grey[600],
    position: 'absolute',
    right: theme.spacing(1.25),
    top: theme.spacing(1.5)
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2)
    }
  },
  periodPanel: {
    background: '#f8f9fb',
    border: '1px solid #e7eaf0',
    borderRadius: 10,
    padding: theme.spacing(2.25)
  },
  sectionLabel: {
    color: '#263238',
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase'
  },
  periodFields: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'minmax(0, 1fr) minmax(140px, 0.55fr)',
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  periodHint: {
    color: '#65747B',
    display: 'block',
    marginTop: theme.spacing(1.25)
  },
  monthSelect: {
    fontWeight: 400,
    '& option': {
      fontWeight: 400
    }
  },
  resultArea: {
    marginTop: theme.spacing(3)
  },
  statePanel: {
    alignItems: 'center',
    border: '1px dashed #d8dde6',
    borderRadius: 10,
    color: '#65747B',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 160,
    padding: theme.spacing(3),
    textAlign: 'center'
  },
  stateProgress: {
    marginBottom: theme.spacing(1.5)
  },
  errorText: {
    color: theme.palette.error.main
  },
  listHeader: {
    alignItems: 'flex-end',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      gap: theme.spacing(1)
    }
  },
  listTitle: {
    color: '#263238',
    fontSize: '1rem',
    fontWeight: 600
  },
  selectionCount: {
    color: '#65747B',
    display: 'block',
    marginTop: theme.spacing(0.25)
  },
  utilityButton: {
    fontSize: '0.78rem',
    minWidth: 0,
    padding: theme.spacing(0.5, 0.75),
    textTransform: 'none'
  },
  groupsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  },
  groupSection: {
    border: '1px solid #e7eaf0',
    borderRadius: 10,
    overflow: 'hidden'
  },
  groupHeader: {
    alignItems: 'center',
    background: '#f8f9fb',
    borderBottom: '1px solid #eef0f4',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: 48,
    padding: theme.spacing(0.25, 1.5)
  },
  groupControl: {
    marginRight: 0
  },
  groupName: {
    color: '#263238',
    fontWeight: 600
  },
  groupCount: {
    color: '#65747B',
    fontSize: '0.75rem',
    whiteSpace: 'nowrap'
  },
  storeGrid: {
    display: 'grid',
    gap: theme.spacing(0.25, 2),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    padding: theme.spacing(1, 1.5, 1.25),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  storeControl: {
    borderRadius: 6,
    margin: 0,
    minHeight: 42,
    paddingRight: theme.spacing(1),
    '&:hover': {
      background: '#f8f9fb'
    }
  },
  storeName: {
    color: '#37474f',
    fontSize: '0.875rem'
  },
  actions: {
    borderTop: `1px solid ${theme.palette.divider}`,
    minHeight: 68,
    padding: theme.spacing(1.5, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 2)
    }
  },
  selectionActions: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      '& > button': {
        width: '100%'
      }
    }
  },
  confirmationActions: {
    justifyContent: 'space-between'
  },
  primaryButton: {
    minWidth: 150
  },
  destructiveButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    minWidth: 150,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  },
  buttonProgress: {
    marginRight: theme.spacing(1)
  },
  confirmation: {
    margin: '0 auto',
    maxWidth: 640
  },
  confirmationEyebrow: {
    color: theme.palette.error.main,
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase'
  },
  confirmationTitle: {
    color: '#263238',
    fontSize: '1.55rem',
    fontWeight: 500,
    lineHeight: 1.35,
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.3rem'
    }
  },
  warningBox: {
    alignItems: 'flex-start',
    background: '#fff5f5',
    border: '1px solid #f3c8c8',
    borderRadius: 10,
    display: 'flex',
    gap: theme.spacing(1.25),
    marginTop: theme.spacing(2.5),
    padding: theme.spacing(1.75)
  },
  warningIcon: {
    color: theme.palette.error.main,
    flexShrink: 0,
    marginTop: 1
  },
  warningTitle: {
    color: '#7f1d1d',
    fontWeight: 700
  },
  warningText: {
    color: '#8a3a3a',
    marginTop: theme.spacing(0.25)
  },
  reviewList: {
    borderTop: '1px solid #eef0f4',
    marginTop: theme.spacing(2.5),
    paddingTop: theme.spacing(2)
  },
  reviewGroup: {
    '& + &': {
      marginTop: theme.spacing(1.5)
    }
  },
  reviewGroupName: {
    color: '#263238',
    fontSize: '0.78rem',
    fontWeight: 700,
    marginBottom: theme.spacing(0.35)
  },
  reviewStoreNames: {
    color: '#65747B',
    lineHeight: 1.55
  }
}))
